import { Col, Container, Row } from "react-bootstrap";
import "./profile-settings.scss";
import { Tabs } from "@veneer/core";
import { useState } from "react";
import { Profile } from "./profile/profile";
import { SavedContact } from "./saved-contact/saved-contact";
import { SiteAddresses } from "./site-addresses/site-addresses";
import { Administration } from "./administration/administration";
import { BulkUpload } from "./bulk-upload/bulk-upload";
import { Trans, useTranslation } from "react-i18next";
export const ProfileSettings = () => {
  const{t}=useTranslation();
  //const adminRole: boolean = (window as any).IsAdmin || false;
  const adminRole: boolean = (window as any).IsAdmin || (window.location.hostname.includes("localhost"))?true:false;
  const IsIndividualRole: boolean =(window as any).IsIndividualRole || false;
  const [activeTab, setActiveTab] = useState(0);
  const changeTabHandler = (id: any) => {
    setActiveTab(id);
  };

  return (
    <Container fluid className="profile-setting-container">
      <div className="profile-inner">
        <div className="header">
          <h2>{t('HPI.Profilepage.ProfileandSettings',{defaultValue:'Profile and Settings'})}</h2>
        </div>
        <div>
          <Container className="card-container">
            <Row>
              <Col sm={12}>
                <h5>{t("HPI.Profilepage.Heading",{defaultValue:'Case management profile settings'})}</h5>
              </Col>
              <Col sm={12} className="mt-3">
                <Tabs
                  controlId="default"
                  mode="contained"
                  onChangeTab={changeTabHandler}
                  selectedTabId={activeTab}
                  tabs={[
                    {
                      id: 0,
                      label: t("HPI.Profilepage.tab.MyProfile",{defaultValue:'My Profile'}),
                      content: (
                        <div>
                          <Profile />
                        </div>
                      ),
                    },
                    ...(!IsIndividualRole
                      ? [{
                        id: 1,
                        label: t("HPI.Profilepage.tab.Savedcontacts", { defaultValue: 'Saved contacts' }),
                        content: (
                          <div>
                            <SavedContact />
                          </div>
                        ),
                      },] : []),

                    ...((!IsIndividualRole && adminRole)
                      ? [
                          {
                            id: 2,
                            label: t("HPI.Profilepage.tab.Siteaddresses",{defaultValue:'Site addresses'}),
                            content: (
                              <div>
                                <SiteAddresses />
                              </div>
                            ),
                          },
                          {
                            id: 3,
                            label: t("HPI.Profilepage.tab.Administration",{defaultValue:'Administration'}),
                            content: (
                              <div>
                                <Administration />
                              </div>
                            ),
                          },
                          {
                            id: 4,
                            label: t("HPI.Profilepage.tab.Bulkupload",{defaultValue:'Bulk upload'}),
                            content: (
                              <div>
                                <BulkUpload />
                              </div>
                            ),
                          },
                        ]
                      : []),
                  ]}
                  type="attached"
                />
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </Container>
  );
};
